import React from 'react';
import TextWinds from '../common/TextWinds';
import { Link } from 'react-router-dom';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { Card, CardBody, CardHeader } from '@material-tailwind/react';
import { legacyCourseListType } from '../../constants/legacyTypes';
import { SUB_TYPE_BY_SLUG } from '../../constants/course-categories';

/*
  카드 본문 래퍼 클래스.
  Link 안에 button을 중첩할 수 없어 Material Tailwind Button을 div로 바꿨고,
  Button이 입히던 스타일(uppercase, text-center, 그림자 등)을 그대로 옮겨 적었다.
*/
const BODY_CLASS =
  'flex h-full flex-col select-none p-0 bg-white rounded-xl shadow-md shadow-gray-900/10 font-sans font-bold text-xs text-center uppercase transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none';

// 카드 바깥 치수. 스켈레톤이 실제 카드와 같은 자리를 차지하도록 공유한다
const SIZE_CLASS = 'm-auto w-full xl:w-[270px]';

/** 로딩 중 자리를 잡아두는 카드 모양 스켈레톤 */
export const CourseCardSkeleton = () => (
  <div className={`${SIZE_CLASS} animate-pulse rounded-xl bg-gray2`}>
    <div className="aspect-[210/120] w-full" />
    <div className="h-[76px] w-full" />
  </div>
);

const CourseCard = ({ data }: { data: legacyCourseListType }) => {
  // 어느 페이지에서 렌더되든 같은 상세 주소를 만들기 위해 카테고리 슬러그를 역조회한다
  const slug = Object.keys(SUB_TYPE_BY_SLUG).find(
    (key) => SUB_TYPE_BY_SLUG[key] === data.product_sub_type,
  );

  return (
    <Link to={`/courses/${slug}/details/${data.id}`}>
      <Card className={`${SIZE_CLASS} h-full shrink-0`}>
        <div className={BODY_CLASS}>
          <CardHeader className="m-0 flex aspect-[210/120] w-full items-center justify-center rounded-b-none rounded-t-xl bg-gray-100 p-0 shadow-none">
            {data.thumbnail?.access_url ? (
              <img
                className="h-full w-full object-contain"
                src={data.thumbnail.access_url}
                alt={data.name}
              />
            ) : (
              <PhotoIcon className="h-[32px] w-[32px]" />
            )}
          </CardHeader>
          <CardBody className="w-full px-[10px] py-[16px]">
            <TextWinds type="content_body4" className="font-semibold">
              {data.name}
            </TextWinds>
            <TextWinds type="content_body4" color="gray7" className="pt-[8px]">
              {data.description}
            </TextWinds>
          </CardBody>
        </div>
      </Card>
    </Link>
  );
};

export default CourseCard;
